import React, { useState, Fragment } from "react";
import gql from "graphql-tag";
import { Mutation, Query, compose } from "react-apollo";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { withNotification } from "../../../notification/context";
import LinearProgress from '@material-ui/core/LinearProgress';
import SelectUniqueField from "./selectUniqueField";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { setCloseStatsPanel } from "../../../data/ducks";

const FileGeneratorSchema = Yup.object().shape({
  layer: Yup.string().required("Requerido"),
  indicator: Yup.string().required("Requerido")
});

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  }
});

const UPDATE = gql`
  mutation($layer: ID!, $indicator: ID!, $uniqueFields : [String!]) {
    createStatsFile(layer: $layer, indicator: $indicator, uniqueFields : $uniqueFields) {
      layer
      location
    }
  }
`;

const QUERY = gql`
  query {
    allIndicators {
      id
      name
      stratifiers {
        name
        order
      }
      demographicVariable
    }
  }
`;

const ButtonDownloadStatsFile = ({ classes, layer, openNotification, setCloseStatsPanel }) => {
  const [open, changeOpen] = useState(false);
  const handleOpen = () => {
    setCloseStatsPanel(true);
    changeOpen(true);
  };
  const handleClose = () => {
    setCloseStatsPanel(false);
    changeOpen(false);
  };
  const [fields, setFields] = useState([]);

  return (
    <Fragment>
      <Button
        className={classes.button}
        variant="outlined"
        color="primary"
        onClick={handleOpen}
      >
        Descargar
      </Button>
      <Mutation mutation={UPDATE}>
        {(createStatsFile, { loading }) => {
          return (
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="download-stats-file-dialog"
              aria-describedby="download-stats-file-dialog"
              fullWidth
              maxWidth="md"
            >
              <DialogTitle id="download-stats-file-dialog">
                Generar plantilla de carga estadística
              </DialogTitle>
              <Formik
                initialValues={{
                  layer,
                  indicator: ""
                }}
                onSubmit={({ indicator }, { resetForm }) => {
                  return createStatsFile({ variables: { indicator, layer, uniqueFields: fields } })
                    .then(({ data: { createStatsFile } }) => {
                      openNotification("Archivo generado correctamente.");
                      resetForm();
                      handleClose();
                      setFields([]);
                      window.open(createStatsFile.location);
                    })
                    .catch(() => {
                      openNotification("Error al generar el archivo.");
                    });
                }}
                validationSchema={FileGeneratorSchema}
              >
                {({ values, handleChange, handleSubmit, isSubmiting }) => {
                  return (
                    <Fragment>
                      <DialogContent style={{height : 400}}>
                        <DialogContentText id="alert-dialog-description">
                          Por favor seleccione el indicador para el cual desea
                          generar el archivo de carga.
                        </DialogContentText>
                        <Query query={QUERY}>
                          {({ loading, error, data }) => {
                            if (loading) {
                              return <LinearProgress variant="query" color="primary"/>;
                            }
                            if(error){
                              return null;
                            }
                            const { allIndicators } = data;
                            const items = allIndicators.map(item => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ));
                            return (
                              <FormControl
                                fullWidth
                                required
                              >
                                <InputLabel htmlFor="indicator-required">
                                  Indicador
                                </InputLabel>
                                <Select
                                  autoWidth
                                  value={values.indicator}
                                  onChange={handleChange}
                                  name="indicator"
                                  inputProps={{
                                    id: "indicator-required"
                                  }}
                                >
                                  <MenuItem value="">
                                    <em>Seleccione un valor</em>
                                  </MenuItem>
                                  {items}
                                </Select>
                                <SelectUniqueField
                                  selected = {(selected) => setFields(selected)}
                                  layer={layer}
                                />
                              </FormControl>
                            );
                          }}
                        </Query>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={handleClose}
                          color="primary"
                          disabled={loading}
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={handleSubmit}
                          color="primary"
                          autoFocus
                          disabled={
                            loading || isSubmiting || values.indicator === ""
                          }
                        >
                          Generar
                        </Button>
                      </DialogActions>
                    </Fragment>
                  );
                }}
              </Formik>
            </Dialog>
          );
        }}
      </Mutation>
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setCloseStatsPanel
}, dispatch);

export default connect(null, mapDispatchToProps)(compose(
  withStyles(styles),
  withNotification
)(ButtonDownloadStatsFile));



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/button-download-stats-file.js